var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"color":"primary","dark":"","icon":"mdi-check","border":"left","prominent":""}},[_vm._v(" "+_vm._s(_vm.$t('partner.job.is_completed'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }